module.exports = __webpack_public_path__ + "img/logo.df6427ec.png";